import { SELECT_PATH } from '../actions/actionTypes';

const selectedPath = ( state = {}, action ) => {
	switch(action.type){
		case SELECT_PATH:
			return action.id
		default:
			return state;
	}
}

export default selectedPath;


// WEBPACK FOOTER //
// ./src/reducers/selectedPath.js